(function(angular){
	'use strict';
	
	var sharedDataVisualizationObject = {
		bindings: {
			highchartsOptions: '<',
			layout: '<',
			showLegend: '<?',
			source: '<',
			subtitle: '<',
			title: '<'
		},
		controller: [
			SharedDataVisualizationFunction
		],
		controllerAs: 'sharedDataVisualization',
		templateUrl: [
			'STATIC_BASE_PATH',
			templateUrlFunction
		]
	};
	
	angular
		.module('sharedDataVisualizationModule')
		.component('sharedDataVisualization', sharedDataVisualizationObject);

	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/' + resolveStaticResource('static/html/shared/data-visualization/shared-data-visualization.html');
	}

	function SharedDataVisualizationFunction() {
		var sharedDataVisualization = this;

		sharedDataVisualization.$onInit = function() {
			sharedDataVisualization.chartLoaded = false;
			sharedDataVisualization.showLegend = sharedDataVisualization.showLegend || false;
		};
	}
})(window.angular);